// extracted by mini-css-extract-plugin
module.exports = {"customScrollbar2":"HighlightedJobListings_customScrollbar2__CXMM7"};